var map = {
	"./Arrow.svg": "d201",
	"./Mobile.svg": "4158",
	"./Safari.svg": "da24",
	"./altering.svg": "1a6e",
	"./anchor_avatar.svg": "d65f",
	"./answer-order.svg": "cf4a",
	"./arrow-blue.svg": "be01",
	"./arrow-orange.svg": "5121",
	"./assistant_avatar.svg": "9cb4",
	"./browser_err.svg": "ae96",
	"./camera.svg": "95d4",
	"./camera_green.svg": "7691",
	"./camera_small.svg": "0175",
	"./camera_small_close.svg": "36ba",
	"./camera_small_close_grey.svg": "f148",
	"./camera_small_disabled.svg": "ac43",
	"./camera_small_grey.svg": "187d",
	"./change.svg": "1e80",
	"./chatavatar_6.svg": "89ca",
	"./chatavatar_7.svg": "17c2",
	"./chatavatar_8.svg": "7d4a",
	"./check-box.svg": "4b33",
	"./check-radio.svg": "ff86",
	"./check_err.svg": "a3ba",
	"./check_pass.svg": "8c01",
	"./checkres.svg": "a99d",
	"./choujiang.svg": "4015",
	"./close-answer.svg": "7421",
	"./close.svg": "fbc2",
	"./close_camera.svg": "6b67",
	"./close_local.svg": "ef5f",
	"./controller.svg": "066a",
	"./correct.svg": "bbf1",
	"./count-down.svg": "3f16",
	"./customer_service.svg": "b5d0",
	"./dati.svg": "a2f1",
	"./default_chatavatar.svg": "5f08",
	"./del-input-ques.svg": "8d3e",
	"./del-input.svg": "9ab4b",
	"./dengfen.svg": "abed",
	"./dianzan.svg": "8022",
	"./doc.svg": "81ac",
	"./doc_active.svg": "764f",
	"./doc_active_orange.svg": "7fe5",
	"./doc_orange.svg": "4059",
	"./download_icon.svg": "caa1",
	"./drag.svg": "eb57",
	"./exclamation.svg": "15a1",
	"./file_icon.svg": "bb14",
	"./file_null.svg": "4acb",
	"./filter_icon.svg": "cb09",
	"./fold.svg": "2cb6",
	"./fold_orange.svg": "2ab5",
	"./forceanswer.svg": "978d",
	"./gift.svg": "e567",
	"./gonggao.svg": "f0f8",
	"./group/group-icon.svg": "d417",
	"./group/group.svg": "357b",
	"./group/group_orange.svg": "51ee",
	"./guest_avatar.svg": "b0dc",
	"./heart-blue.svg": "37b0",
	"./heart-question.svg": "2567",
	"./heart.svg": "61da",
	"./icon-add-orange.svg": "41ea",
	"./icon-add-question.svg": "f5fb",
	"./icon-close-cutdown.svg": "852d",
	"./icon-close-light.svg": "1e72",
	"./icon-del-red.svg": "a3c7",
	"./icon-del-white.svg": "d533",
	"./icon-del.svg": "5c9c",
	"./icon-dot-blue.svg": "f106",
	"./icon-dot.svg": "26dc",
	"./icon-emoji.svg": "64eb",
	"./icon-img.svg": "e5e7",
	"./icon-large.svg": "77b7",
	"./icon-list-more.svg": "7462",
	"./icon-mini-light.svg": "a6db",
	"./icon-mini.svg": "01cf",
	"./icon-refresh-light.svg": "d0ad",
	"./icon-refresh.svg": "b221",
	"./icon-replay-light.svg": "4ad7",
	"./icon-replay.svg": "d537",
	"./icon-resume-light.svg": "11a2",
	"./icon-resume.svg": "15cc",
	"./icon-stop.svg": "857c",
	"./icon-tips.svg": "270e",
	"./icon/icon-answer.svg": "dae8",
	"./icon/icon-arrow-down.svg": "33c0",
	"./icon/icon-arrow.svg": "823f",
	"./icon/icon-attendee.svg": "bc19",
	"./icon/icon-chat.svg": "ee20",
	"./icon/icon-check-auto.svg": "88ec",
	"./icon/icon-checkin.svg": "ab0a",
	"./icon/icon-clear.svg": "6369",
	"./icon/icon-clock.svg": "c9a0",
	"./icon/icon-close.svg": "deca",
	"./icon/icon-commity.svg": "723a",
	"./icon/icon-download.svg": "8788",
	"./icon/icon-draw.svg": "3d82",
	"./icon/icon-emoji.svg": "7eff",
	"./icon/icon-fullscreen.svg": "740e",
	"./icon/icon-heart.svg": "1705",
	"./icon/icon-img.svg": "63a9",
	"./icon/icon-import.svg": "c9d2",
	"./icon/icon-layout-2.svg": "8207",
	"./icon/icon-layout.svg": "241e",
	"./icon/icon-list-more.svg": "89c0",
	"./icon/icon-live.svg": "3c17",
	"./icon/icon-mic.svg": "f43f",
	"./icon/icon-move-down.svg": "8396",
	"./icon/icon-move-up.svg": "4129",
	"./icon/icon-move.svg": "572fa",
	"./icon/icon-mute.svg": "7a18",
	"./icon/icon-notice.svg": "9c4f",
	"./icon/icon-push-all.svg": "6fb7",
	"./icon/icon-push.svg": "831d",
	"./icon/icon-questionnaire.svg": "939d",
	"./icon/icon-record.svg": "f69f",
	"./icon/icon-recordding.svg": "87c0",
	"./icon/icon-search.svg": "5542",
	"./icon/icon-share.svg": "1c74",
	"./icon/icon-show.svg": "7b25",
	"./icon/icon-sticker.svg": "eabd",
	"./icon/icon-success.svg": "7319",
	"./icon/icon-tips.svg": "6937",
	"./icon/icon-viewer.svg": "fb2e",
	"./icon/icon-volume.svg": "41a0",
	"./icon/icon-word.svg": "fcec",
	"./icon/icon-wx.svg": "25b2",
	"./icon/no-permission-min.svg": "631c",
	"./icon/no-permission.svg": "30e7",
	"./icon/reduce.svg": "80bc",
	"./koulingchoujiang.svg": "4970",
	"./layout.svg": "cfd2",
	"./layout_active.svg": "9b05",
	"./layout_active_orange.svg": "396d",
	"./layout_disabled.svg": "9f70",
	"./layout_disabled_orange.svg": "7bb0",
	"./layout_orange.svg": "8d2c",
	"./lianmai.svg": "eebf",
	"./lianmai_active.svg": "cbcc",
	"./lianmai_active_orange.svg": "eb36",
	"./lianmai_mute.svg": "9f38",
	"./lianmai_mute_orange.svg": "093f",
	"./lianmai_orange.svg": "2891",
	"./liveTime.svg": "e9b1",
	"./loading.svg": "c637",
	"./local_set.svg": "5944",
	"./local_setting.svg": "14af",
	"./local_video.svg": "372e",
	"./local_video_close.svg": "90a9",
	"./local_video_close2.svg": "1c0d",
	"./login_name.svg": "5184",
	"./login_pass.svg": "f8ec",
	"./mic-sprite.svg": "5b51",
	"./mic.svg": "99bc",
	"./mic1.svg": "14ab",
	"./mic_close.svg": "b97c",
	"./mic_close2.svg": "fb90",
	"./mic_close_0.svg": "9829",
	"./mic_green.svg": "70cc",
	"./mic_main.svg": "7b73",
	"./mic_main2.svg": "1bee",
	"./mic_open.svg": "1fda",
	"./mic_small.svg": "b5fb",
	"./mic_small_close.svg": "ef4e",
	"./mic_small_close_grey.svg": "530f",
	"./mic_small_disabled.svg": "8540",
	"./mic_small_grey.svg": "795e",
	"./mix.svg": "d510",
	"./mix_1.svg": "b476",
	"./mobile-blank.svg": "10f7",
	"./mobile_device.svg": "2bca",
	"./more-chat.svg": "767f",
	"./more.svg": "398d",
	"./more_setting.svg": "3ab4",
	"./multimedia.svg": "24d2",
	"./multimedia_active.svg": "29f6",
	"./multimedia_active_orange.svg": "99f1",
	"./multimedia_orange.svg": "b20c",
	"./no-ask-light.svg": "6d3a",
	"./no-ask.svg": "fca9",
	"./no-reward.svg": "4f4d",
	"./no-reward_orange.svg": "e3d8",
	"./nocamera.svg": "0f02",
	"./noreceiverecord.svg": "6f95",
	"./number1.svg": "2267",
	"./number2.svg": "ca34",
	"./number3.svg": "761f",
	"./open-answer.svg": "ec42",
	"./open.svg": "48ef",
	"./open_app.svg": "3f4d",
	"./open_local.svg": "e612",
	"./option.svg": "1e9a",
	"./packup.svg": "5173",
	"./pc_device.svg": "114b",
	"./phone_icon.svg": "80ca",
	"./ping.svg": "d8ba",
	"./prise-blue.svg": "f0a4",
	"./prise-question.svg": "0010",
	"./prise.svg": "247f",
	"./pulldown.svg": "27e2",
	"./qiandao.svg": "9e3f",
	"./recomed.svg": "ea06",
	"./record.svg": "d506",
	"./recording.svg": "38a6",
	"./redpacket_bg.svg": "9eaa",
	"./redpacket_close.svg": "e9ed",
	"./redpacket_icon.svg": "6093",
	"./redpacket_tool.svg": "508d",
	"./refresh.svg": "681d",
	"./reward.svg": "61e7",
	"./reward_go.svg": "ad83",
	"./rewards.svg": "95dd",
	"./row-question.svg": "7bab",
	"./same-ask-dark.svg": "e009",
	"./same-ask-light.svg": "ff6e",
	"./selected-yellow.svg": "2d71",
	"./selected.svg": "826c",
	"./sensitive_icon.svg": "276d",
	"./setting.svg": "d003",
	"./shangpin.svg": "9169",
	"./share.svg": "3eb5",
	"./share_active.svg": "4d94",
	"./share_active_orange.svg": "03c5",
	"./share_disabled.svg": "e5eb",
	"./share_orange.svg": "c89c",
	"./silenced_icon.svg": "05b9",
	"./single-mic-sprite.svg": "311e",
	"./single_bad.svg": "c31d",
	"./single_better.svg": "67cd",
	"./single_moderate.svg": "1f20",
	"./speaker-small-close.svg": "90d1",
	"./speaker-small.svg": "dc70",
	"./speaker.svg": "c24c",
	"./spread.svg": "eedd",
	"./star-blue.svg": "db3f",
	"./star-question.svg": "e0a1",
	"./tip.svg": "e5bc",
	"./tool.svg": "761a",
	"./tool_active.svg": "6651",
	"./tool_active_orange.svg": "d6b4",
	"./tool_orange.svg": "8c5d",
	"./unfold.svg": "30c2",
	"./unfold_orange.svg": "99b6",
	"./up-host-yellow.svg": "84ce",
	"./up_host.svg": "0458",
	"./upload.svg": "27ac",
	"./video_exitfull.svg": "ca3b",
	"./video_fullscreen.svg": "fbba",
	"./video_hide.svg": "eeff",
	"./video_main.svg": "1e36",
	"./video_main2.svg": "ea0c",
	"./video_max.svg": "d008",
	"./video_show.svg": "8875",
	"./video_transter.svg": "1226",
	"./viewer.svg": "872c",
	"./viewer_avatar.svg": "5c45",
	"./violation-show.svg": "9863",
	"./violation.svg": "c996",
	"./volume-close.svg": "25e9",
	"./volume-open.svg": "75c0",
	"./wechatpay.svg": "3001",
	"./wenjuan.svg": "8d7f",
	"./whiteboard.svg": "7c3b",
	"./whiteboard_active.svg": "77e1",
	"./whiteboard_active_orange.svg": "652d",
	"./whiteboard_orange.svg": "e0ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49ab";